import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Alert, message as messageUI } from 'antd';
import { closeNotificationMessage } from 'ACTIONS/app.actions';
import './Notification.less';

// TODO -  Add the ability to have different types of notifications like:
// https://ant.design/components/message/

class Notification extends Component {
  componentDidUpdate() {
    if (this.props.notificationType === 'message' && this.props.visible) {
      const { type, message } = this.props;
      switch (type) {
        case 'info':
        case 'warning':
          return messageUI.warning(message, 5);
        case 'error':
          return messageUI.error(message, 5);
        default:
          return messageUI.success(message, 5);
      }
    }
  }
  render() {
    const {
      title,
      message,
      visible,
      type,
      notificationType,
      closeNotificationMessage: closeNotificationMessageAction,
    } = this.props;

    if (!visible || notificationType === 'message') {
      return null;
    }

    return (
      <div className="notification-wrapper">
        <Alert
          closable
          afterClose={closeNotificationMessageAction}
          title={title}
          message={message}
          type={type}
        />
      </div>
    );
  }
}

Notification.defaultProps = {
  visible: false,
  title: '',
  message: '',
  type: 'info',
  notificationType: 'alert',
};

Notification.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
  notificationType: PropTypes.oneOf(['alert', 'message']),
  closeNotificationMessage: PropTypes.func.isRequired,
};

const mapStateToProps = ({ app }) => app.notification;

const enhance = compose(connect(mapStateToProps, { closeNotificationMessage }), injectIntl);

export default enhance(Notification);



// WEBPACK FOOTER //
// ./src/components/ui/Notification/Notification.js